import { AvatarSex } from "@seddi/avatar";
import { AvatarTextureLayer } from "../types/avatarTexturesTypes";
import { SkinTone, CoverageLevel, CoverageColor } from "../types/displayTypes";
// SKIN
import MonkRoughnessTexture from "../../../assets/avatars/skin/monk_roughness.jpeg";
import MonkNormalTexture from "../../../assets/avatars/skin/monk_normal.jpeg";
import MonkSpecularTexture from "../../../assets/avatars/skin/monk_specular.jpeg";
import SimpleRoughnessTexture from "../../../assets/avatars/skin/simple_roughness.jpeg";
import SimpleNormalTexture from "../../../assets/avatars/skin/simple_normal.jpeg";
import SimpleSpecularTexture from "../../../assets/avatars/skin/simple_specular.jpeg";
import Monk01SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk01_base_color.jpeg";
import Monk02SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk02_base_color.jpeg";
import Monk03SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk03_base_color.jpeg";
import Monk04SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk04_base_color.jpeg";
import Monk05SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk05_base_color.jpeg";
import Monk06SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk06_base_color.jpeg";
import Monk07SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk07_base_color.jpeg";
import Monk08SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk08_base_color.jpeg";
import Monk09SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk09_base_color.jpeg";
import Monk10SkinBaseColorTextureF from "../../../assets/avatars/skin/female/monk10_base_color.jpeg";
import Monk01SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk01_base_color.jpeg";
import Monk02SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk02_base_color.jpeg";
import Monk03SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk03_base_color.jpeg";
import Monk04SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk04_base_color.jpeg";
import Monk05SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk05_base_color.jpeg";
import Monk06SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk06_base_color.jpeg";
import Monk07SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk07_base_color.jpeg";
import Monk08SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk08_base_color.jpeg";
import Monk09SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk09_base_color.jpeg";
import Monk10SkinBaseColorTextureM from "../../../assets/avatars/skin/male/monk10_base_color.jpeg";
import BlackSkinBaseColorTexture from "../../../assets/avatars/skin/black_base_color.jpeg";
import GraySkinBaseColorTexture from "../../../assets/avatars/skin/gray_base_color.jpeg";
import WhiteSkinBaseColorTexture from "../../../assets/avatars/skin/white_base_color.jpeg";
// TOP
import FemaleMinimalTopRoughnessTexture from "../../../assets/avatars/top/minimal/female/roughness.jpeg";
import FemaleMinimalTopSpecularTexture from "../../../assets/avatars/top/minimal/female/specular.jpeg";
import FemaleMinimalTopNormalTexture from "../../../assets/avatars/top/minimal/female/normal.jpeg";
import FemaleMinimalTopWhiteBaseColor from "../../../assets/avatars/top/minimal/female/base_color_white.jpeg";
import FemaleMinimalTopGrayBaseColor from "../../../assets/avatars/top/minimal/female/base_color_gray.jpeg";
import FemaleMinimalTopBlackBaseColor from "../../../assets/avatars/top/minimal/female/base_color_black.jpeg";
import FemaleMinimalTopMask from "../../../assets/avatars/top/minimal/female/mask.jpeg";
import MaleModerateTopRoughnessTexture from "../../../assets/avatars/top/moderate/male/roughness.jpeg";
import MaleModerateTopSpecularTexture from "../../../assets/avatars/top/moderate/male/specular.jpeg";
import MaleModerateTopNormalTexture from "../../../assets/avatars/top/moderate/male/normal.jpeg";
import MaleModerateTopWhiteBaseColor from "../../../assets/avatars/top/moderate/male/base_color_white.jpeg";
import MaleModerateTopGrayBaseColor from "../../../assets/avatars/top/moderate/male/base_color_gray.jpeg";
import MaleModerateTopBlackBaseColor from "../../../assets/avatars/top/moderate/male/base_color_black.jpeg";
import MaleModerateTopMask from "../../../assets/avatars/top/moderate/male/mask.jpeg";
import FemaleModerateTopRoughnessTexture from "../../../assets/avatars/top/moderate/female/roughness.jpeg";
import FemaleModerateTopSpecularTexture from "../../../assets/avatars/top/moderate/female/specular.jpeg";
import FemaleModerateTopNormalTexture from "../../../assets/avatars/top/moderate/female/normal.jpeg";
import FemaleModerateTopWhiteBaseColor from "../../../assets/avatars/top/moderate/female/base_color_white.jpeg";
import FemaleModerateTopGrayBaseColor from "../../../assets/avatars/top/moderate/female/base_color_gray.jpeg";
import FemaleModerateTopBlackBaseColor from "../../../assets/avatars/top/moderate/female/base_color_black.jpeg";
import FemaleModerateTopMask from "../../../assets/avatars/top/moderate/female/mask.jpeg";
import UnisexMaximumTopRoughnessTexture from "../../../assets/avatars/top/maximum/roughness.jpeg";
import UnisexMaximumTopSpecularTexture from "../../../assets/avatars/top/maximum/specular.jpeg";
import UnisexMaximumTopNormalTexture from "../../../assets/avatars/top/maximum/normal.jpeg";
import UnisexMaximumTopWhiteBaseColor from "../../../assets/avatars/top/maximum/base_color_white.jpeg";
import UnisexMaximumTopGrayBaseColor from "../../../assets/avatars/top/maximum/base_color_gray.jpeg";
import UnisexMaximumTopBlackBaseColor from "../../../assets/avatars/top/maximum/base_color_black.jpeg";
import UnisexMaximumTopMask from "../../../assets/avatars/top/maximum/mask.jpeg";
// BOTTOM
import MaleMinimalBottomRoughnessTexture from "../../../assets/avatars/bottom/minimal/male/roughness.jpeg";
import MaleMinimalBottomSpecularTexture from "../../../assets/avatars/bottom/minimal/male/specular.jpeg";
import MaleMinimalBottomNormalTexture from "../../../assets/avatars/bottom/minimal/male/normal.jpeg";
import MaleMinimalBottomWhiteBaseColor from "../../../assets/avatars/bottom/minimal/male/base_color_white.jpeg";
import MaleMinimalBottomGrayBaseColor from "../../../assets/avatars/bottom/minimal/male/base_color_gray.jpeg";
import MaleMinimalBottomBlackBaseColor from "../../../assets/avatars/bottom/minimal/male/base_color_black.jpeg";
import MaleMinimalBottomMask from "../../../assets/avatars/bottom/minimal/male/mask.jpeg";
import FemaleMinimalBottomRoughnessTexture from "../../../assets/avatars/bottom/minimal/female/roughness.jpeg";
import FemaleMinimalBottomSpecularTexture from "../../../assets/avatars/bottom/minimal/female/specular.jpeg";
import FemaleMinimalBottomNormalTexture from "../../../assets/avatars/bottom/minimal/female/normal.jpeg";
import FemaleMinimalBottomWhiteBaseColor from "../../../assets/avatars/bottom/minimal/female/base_color_white.jpeg";
import FemaleMinimalBottomGrayBaseColor from "../../../assets/avatars/bottom/minimal/female/base_color_gray.jpeg";
import FemaleMinimalBottomBlackBaseColor from "../../../assets/avatars/bottom/minimal/female/base_color_black.jpeg";
import FemaleMinimalBottomMask from "../../../assets/avatars/bottom/minimal/female/mask.jpeg";
import UnisexModerateBottomRoughnessTexture from "../../../assets/avatars/bottom/moderate/roughness.jpeg";
import UnisexModerateBottomSpecularTexture from "../../../assets/avatars/bottom/moderate/specular.jpeg";
import UnisexModerateBottomNormalTexture from "../../../assets/avatars/bottom/moderate/normal.jpeg";
import UnisexModerateBottomWhiteBaseColor from "../../../assets/avatars/bottom/moderate/base_color_white.jpeg";
import UnisexModerateBottomGrayBaseColor from "../../../assets/avatars/bottom/moderate/base_color_gray.jpeg";
import UnisexModerateBottomBlackBaseColor from "../../../assets/avatars/bottom/moderate/base_color_black.jpeg";
import UnisexModerateBottomMask from "../../../assets/avatars/bottom/moderate/mask.jpeg";
import UnisexMaximumBottomRoughnessTexture from "../../../assets/avatars/bottom/maximum/roughness.jpeg";
import UnisexMaximumBottomSpecularTexture from "../../../assets/avatars/bottom/maximum/specular.jpeg";
import UnisexMaximumBottomNormalTexture from "../../../assets/avatars/bottom/maximum/normal.jpeg";
import UnisexMaximumBottomWhiteBaseColor from "../../../assets/avatars/bottom/maximum/base_color_white.jpeg";
import UnisexMaximumBottomGrayBaseColor from "../../../assets/avatars/bottom/maximum/base_color_gray.jpeg";
import UnisexMaximumBottomBlackBaseColor from "../../../assets/avatars/bottom/maximum/base_color_black.jpeg";
import UnisexMaximumBottomMask from "../../../assets/avatars/bottom/maximum/mask.jpeg";

export const TopNormalTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: "", // Male minimal top is naked
    [CoverageLevel.MODERATE]: MaleModerateTopNormalTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopNormalTexture,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalTopNormalTexture,
    [CoverageLevel.MODERATE]: FemaleModerateTopNormalTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopNormalTexture,
  },
};

export const TopRoughnessTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: "", // Male minimal top is naked
    [CoverageLevel.MODERATE]: MaleModerateTopRoughnessTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopRoughnessTexture,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalTopRoughnessTexture,
    [CoverageLevel.MODERATE]: FemaleModerateTopRoughnessTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopRoughnessTexture,
  },
};

export const TopSpecularTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: "", // Male minimal top is naked
    [CoverageLevel.MODERATE]: MaleModerateTopSpecularTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopSpecularTexture,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalTopSpecularTexture,
    [CoverageLevel.MODERATE]: FemaleModerateTopSpecularTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopSpecularTexture,
  },
};

export const TopMaskTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: "", // Male minimal top is naked,
    [CoverageLevel.MODERATE]: MaleModerateTopMask,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopMask,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalTopMask,
    [CoverageLevel.MODERATE]: FemaleModerateTopMask,
    [CoverageLevel.MAXIMUM]: UnisexMaximumTopMask,
  },
};

export const TopBaseColorTextures = {
  [CoverageColor.WHITE]: {
    [AvatarSex.Male]: {
      [CoverageLevel.MINIMAL]: "", // Male minimal top is naked
      [CoverageLevel.MODERATE]: MaleModerateTopWhiteBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumTopWhiteBaseColor,
    },
    [AvatarSex.Female]: {
      [CoverageLevel.MINIMAL]: FemaleMinimalTopWhiteBaseColor,
      [CoverageLevel.MODERATE]: FemaleModerateTopWhiteBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumTopWhiteBaseColor,
    },
  },
  [CoverageColor.GRAY]: {
    [AvatarSex.Male]: {
      [CoverageLevel.MINIMAL]: "", // Male minimal top is naked
      [CoverageLevel.MODERATE]: MaleModerateTopGrayBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumTopGrayBaseColor,
    },
    [AvatarSex.Female]: {
      [CoverageLevel.MINIMAL]: FemaleMinimalTopGrayBaseColor,
      [CoverageLevel.MODERATE]: FemaleModerateTopGrayBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumTopGrayBaseColor,
    },
  },
  [CoverageColor.BLACK]: {
    [AvatarSex.Male]: {
      [CoverageLevel.MINIMAL]: "", // Male minimal top is naked
      [CoverageLevel.MODERATE]: MaleModerateTopBlackBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumTopBlackBaseColor,
    },
    [AvatarSex.Female]: {
      [CoverageLevel.MINIMAL]: FemaleMinimalTopBlackBaseColor,
      [CoverageLevel.MODERATE]: FemaleModerateTopBlackBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumTopBlackBaseColor,
    },
  },
};

export const BottomNormalTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: MaleMinimalBottomNormalTexture,
    [CoverageLevel.MODERATE]: UnisexModerateBottomNormalTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomNormalTexture,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalBottomNormalTexture,
    [CoverageLevel.MODERATE]: UnisexModerateBottomNormalTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomNormalTexture,
  },
};

export const BottomRoughnessTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: MaleMinimalBottomRoughnessTexture,
    [CoverageLevel.MODERATE]: UnisexModerateBottomRoughnessTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomRoughnessTexture,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalBottomRoughnessTexture,
    [CoverageLevel.MODERATE]: UnisexModerateBottomRoughnessTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomRoughnessTexture,
  },
};

export const BottomSpecularTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: MaleMinimalBottomSpecularTexture,
    [CoverageLevel.MODERATE]: UnisexModerateBottomSpecularTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomSpecularTexture,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalBottomSpecularTexture,
    [CoverageLevel.MODERATE]: UnisexModerateBottomSpecularTexture,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomSpecularTexture,
  },
};

export const BottomMaskTextures = {
  [AvatarSex.Male]: {
    [CoverageLevel.MINIMAL]: MaleMinimalBottomMask,
    [CoverageLevel.MODERATE]: UnisexModerateBottomMask,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomMask,
  },
  [AvatarSex.Female]: {
    [CoverageLevel.MINIMAL]: FemaleMinimalBottomMask,
    [CoverageLevel.MODERATE]: UnisexModerateBottomMask,
    [CoverageLevel.MAXIMUM]: UnisexMaximumBottomMask,
  },
};

export const BottomBaseColorTextures = {
  [CoverageColor.WHITE]: {
    [AvatarSex.Male]: {
      [CoverageLevel.MINIMAL]: MaleMinimalBottomWhiteBaseColor,
      [CoverageLevel.MODERATE]: UnisexModerateBottomWhiteBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumBottomWhiteBaseColor,
    },
    [AvatarSex.Female]: {
      [CoverageLevel.MINIMAL]: FemaleMinimalBottomWhiteBaseColor,
      [CoverageLevel.MODERATE]: UnisexModerateBottomWhiteBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumBottomWhiteBaseColor,
    },
  },
  [CoverageColor.GRAY]: {
    [AvatarSex.Male]: {
      [CoverageLevel.MINIMAL]: MaleMinimalBottomGrayBaseColor,
      [CoverageLevel.MODERATE]: UnisexModerateBottomGrayBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumBottomGrayBaseColor,
    },
    [AvatarSex.Female]: {
      [CoverageLevel.MINIMAL]: FemaleMinimalBottomGrayBaseColor,
      [CoverageLevel.MODERATE]: UnisexModerateBottomGrayBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumBottomGrayBaseColor,
    },
  },
  [CoverageColor.BLACK]: {
    [AvatarSex.Male]: {
      [CoverageLevel.MINIMAL]: MaleMinimalBottomBlackBaseColor,
      [CoverageLevel.MODERATE]: UnisexModerateBottomBlackBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumBottomBlackBaseColor,
    },
    [AvatarSex.Female]: {
      [CoverageLevel.MINIMAL]: FemaleMinimalBottomBlackBaseColor,
      [CoverageLevel.MODERATE]: UnisexModerateBottomBlackBaseColor,
      [CoverageLevel.MAXIMUM]: UnisexMaximumBottomBlackBaseColor,
    },
  },
};

export const SkinSpecularTextures = {
  [SkinTone.BROWN_0]: MonkSpecularTexture,
  [SkinTone.BROWN_1]: MonkSpecularTexture,
  [SkinTone.BROWN_2]: MonkSpecularTexture,
  [SkinTone.BROWN_3]: MonkSpecularTexture,
  [SkinTone.BROWN_4]: MonkSpecularTexture,
  [SkinTone.BROWN_5]: MonkSpecularTexture,
  [SkinTone.BROWN_6]: MonkSpecularTexture,
  [SkinTone.BROWN_7]: MonkSpecularTexture,
  [SkinTone.BROWN_8]: MonkSpecularTexture,
  [SkinTone.BROWN_9]: MonkSpecularTexture,
  [SkinTone.WHITE]: SimpleSpecularTexture,
  [SkinTone.GRAY]: SimpleSpecularTexture,
  [SkinTone.BLACK]: SimpleSpecularTexture,
};

export const SkinNormalTextures = {
  [SkinTone.BROWN_0]: MonkNormalTexture,
  [SkinTone.BROWN_1]: MonkNormalTexture,
  [SkinTone.BROWN_2]: MonkNormalTexture,
  [SkinTone.BROWN_3]: MonkNormalTexture,
  [SkinTone.BROWN_4]: MonkNormalTexture,
  [SkinTone.BROWN_5]: MonkNormalTexture,
  [SkinTone.BROWN_6]: MonkNormalTexture,
  [SkinTone.BROWN_7]: MonkNormalTexture,
  [SkinTone.BROWN_8]: MonkNormalTexture,
  [SkinTone.BROWN_9]: MonkNormalTexture,
  [SkinTone.WHITE]: SimpleNormalTexture,
  [SkinTone.GRAY]: SimpleNormalTexture,
  [SkinTone.BLACK]: SimpleNormalTexture,
};

export const SkinRoughnessTextures = {
  [SkinTone.BROWN_0]: MonkRoughnessTexture,
  [SkinTone.BROWN_1]: MonkRoughnessTexture,
  [SkinTone.BROWN_2]: MonkRoughnessTexture,
  [SkinTone.BROWN_3]: MonkRoughnessTexture,
  [SkinTone.BROWN_4]: MonkRoughnessTexture,
  [SkinTone.BROWN_5]: MonkRoughnessTexture,
  [SkinTone.BROWN_6]: MonkRoughnessTexture,
  [SkinTone.BROWN_7]: MonkRoughnessTexture,
  [SkinTone.BROWN_8]: MonkRoughnessTexture,
  [SkinTone.BROWN_9]: MonkRoughnessTexture,
  [SkinTone.WHITE]: SimpleRoughnessTexture,
  [SkinTone.GRAY]: SimpleRoughnessTexture,
  [SkinTone.BLACK]: SimpleRoughnessTexture,
};

export const SkinBaseColorTextures = {
  [AvatarSex.Female]: {
    [SkinTone.BROWN_0]: Monk01SkinBaseColorTextureF,
    [SkinTone.BROWN_1]: Monk02SkinBaseColorTextureF,
    [SkinTone.BROWN_2]: Monk03SkinBaseColorTextureF,
    [SkinTone.BROWN_3]: Monk04SkinBaseColorTextureF,
    [SkinTone.BROWN_4]: Monk05SkinBaseColorTextureF,
    [SkinTone.BROWN_5]: Monk06SkinBaseColorTextureF,
    [SkinTone.BROWN_6]: Monk07SkinBaseColorTextureF,
    [SkinTone.BROWN_7]: Monk08SkinBaseColorTextureF,
    [SkinTone.BROWN_8]: Monk09SkinBaseColorTextureF,
    [SkinTone.BROWN_9]: Monk10SkinBaseColorTextureF,
    [SkinTone.WHITE]: WhiteSkinBaseColorTexture,
    [SkinTone.GRAY]: GraySkinBaseColorTexture,
    [SkinTone.BLACK]: BlackSkinBaseColorTexture,
  },
  [AvatarSex.Male]: {
    [SkinTone.BROWN_0]: Monk01SkinBaseColorTextureM,
    [SkinTone.BROWN_1]: Monk02SkinBaseColorTextureM,
    [SkinTone.BROWN_2]: Monk03SkinBaseColorTextureM,
    [SkinTone.BROWN_3]: Monk04SkinBaseColorTextureM,
    [SkinTone.BROWN_4]: Monk05SkinBaseColorTextureM,
    [SkinTone.BROWN_5]: Monk06SkinBaseColorTextureM,
    [SkinTone.BROWN_6]: Monk07SkinBaseColorTextureM,
    [SkinTone.BROWN_7]: Monk08SkinBaseColorTextureM,
    [SkinTone.BROWN_8]: Monk09SkinBaseColorTextureM,
    [SkinTone.BROWN_9]: Monk10SkinBaseColorTextureM,
    [SkinTone.WHITE]: WhiteSkinBaseColorTexture,
    [SkinTone.GRAY]: GraySkinBaseColorTexture,
    [SkinTone.BLACK]: BlackSkinBaseColorTexture,
  },
};

export const NormalTextures = {
  [AvatarTextureLayer.SKIN]: SkinNormalTextures,
  [AvatarTextureLayer.BOTTOM]: BottomNormalTextures,
  [AvatarTextureLayer.TOP]: TopNormalTextures,
};

export const RoughnessTextures = {
  [AvatarTextureLayer.SKIN]: SkinRoughnessTextures,
  [AvatarTextureLayer.BOTTOM]: BottomRoughnessTextures,
  [AvatarTextureLayer.TOP]: TopRoughnessTextures,
};

export const SpecularTextures = {
  [AvatarTextureLayer.SKIN]: SkinSpecularTextures,
  [AvatarTextureLayer.BOTTOM]: BottomSpecularTextures,
  [AvatarTextureLayer.TOP]: TopSpecularTextures,
};

export const BaseColorTextures = {
  [AvatarTextureLayer.SKIN]: SkinBaseColorTextures,
  [AvatarTextureLayer.BOTTOM]: BottomBaseColorTextures,
  [AvatarTextureLayer.TOP]: TopBaseColorTextures,
};

export const MaskTextures = {
  [AvatarTextureLayer.BOTTOM]: BottomMaskTextures,
  [AvatarTextureLayer.TOP]: TopMaskTextures,
};
